import React from 'react';
import { Icon } from '@progress/kendo-react-common';

const BaseIcon = (props) => <Icon {...props} />;

export default BaseIcon;
